<template>
  <body class="bg-blue-light">
    <div class="height-css snippet-body">
      <header class="header position-relative">
        <div class="">
          <div class="logo align-self-center d-flex">
            <div class="d-flex">
              <img
                src="@/assets/img/logo.png"
                height="45"
                alt="Porto Admin"
                class="system_logo"
              />
            </div>
            <div
              class="h4 font-weight-bold text-blue ms-2 mb-0 mt-0 align-self-center"
            >
              智慧景區管理平台
            </div>
          </div>
        </div>
      </header>

      <div class="mx-auto pb-5">
        <div class="text-center">
          <h1 class="mt-2">緊急求救 解除通報</h1>
        </div>
        <div class="mx-auto col-sm-12 col-md-6" v-if="!updateStatus">
          <form>
            <div class="form-group">
              <div class="col-10 mx-auto bg-white px-3 py-3 rounded-3">
                <legend
                  class="col-form-label  pt-0 fs-6"
                  for="validationDefault01"
                >
                通報人員
                <!-- <p class="ms-2 text-danger"> -->
                <p class="ms-2 text-danger" v-show="alertNullAccount">
                  * 請填寫通報人員
                </p>
                </legend>
                <input
                  type="text"
                  class="form-control mt-2 mb-4"
                  id=" validationDefault01"
                  placeholder="請填寫人員名稱"
                  v-model="inputAccount"
                  required
                />
                <legend class="col-form-label  pt-0 fs-6">
                  解除原因
                  <p class="ms-2 text-danger" v-show="alertNullContent">
                    * 請選擇回報原因
                  </p>
                </legend>

                <div class="">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="gridRadios"
                      id="gridRadios1"
                      :value="CONST.REASON_ONE"
                      v-model="dismissedContent"
                    />
                    <label class="form-check-label" for="gridRadios1">
                      {{ CONST.REASON_ONE }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="gridRadios"
                      id="gridRadios2"
                      :value="CONST.REASON_TWO"
                      v-model="dismissedContent"
                    />
                    <label class="form-check-label" for="gridRadios2">
                      {{ CONST.REASON_TWO }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="gridRadios"
                      id="gridRadios3"
                      :value="CONST.REASON_THREE"
                      v-model="dismissedContent"
                    />
                    <label class="form-check-label" for="gridRadios3">
                      {{ CONST.REASON_THREE }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="gridRadios"
                      id="gridRadios4"
                      :value="CONST.REASON_FOUR"
                      v-model="dismissedContent"
                    />
                    <label class="form-check-label" for="gridRadios4">
                      {{ CONST.REASON_FOUR }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="gridRadios"
                      id="gridRadios5"
                      :value="CONST.REASON_FIVE"
                      v-model="dismissedContent"
                    />
                    <label class="form-check-label w-100" for="gridRadios5">
                      {{ CONST.REASON_FIVE }}
                      <input
                        type="text"
                        class="form-control mt-2"
                        id="colFormLabelLg"
                        placeholder="請填寫原因"
                        v-model="inputContent"
                      />
                    </label>
                  </div>
                </div>
                <div class="d-grid gap-2 col-6 mx-auto mt-3">
                  <button
                    class="btn btn-primary fw-bolder"
                    type="button"
                    @click="sendDissmissContent"
                  >
                    確定送出
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="mx-auto col-12 col-sm-8 col-md-6" v-if="updateStatus">
          <div class="mx-auto bg-white px-3 py-3 rounded-3">
            <h3 class="text-center mb-4 fw-bold text-sign">已完成解除</h3>
            <div class="mx-auto width-fit">
              <p class="fs-6 mb-2">事件編號：{{ this.eventId }}</p>

              <p class="fs-6 mb-2">解除人員：{{ this.inputAccount }}</p>
              <p class="fs-6 mb-2">
                解除原因：{{
                this.dismissedContent === CONST.REASON_FIVE ? this.inputContent : this.dismissedContent
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import exportCSV from "../../utils/exportCSV";

export default {
  components: {},
  data() {
    return {
      CONST: CONST,

      startTime: moment().startOf("day").format(),
      endTime: moment().startOf("minute").format(),
      selectScenicAreaId: -1,
      selectDismissStatus: 1,
      selectDismissContent: CONST.SOS_DISSMISS_CONTENT.ALL,
      eventId: [],
      dismissedContent: "",
      inputContent: "",
      inputAccount: "",
      updateStatus: false,
      alertNullContent: false,
      alertNullAccount: false,
    };
  },
  created() {
    this.eventId = this.$route.query.eventId;
    console.log("eventId", this.eventId);
  },
  computed: {
    ...mapGetters("scenicArea", { myScenicAreaList: "getMyScenicArea" }),

    sosScenicArea() {
      return this.myScenicAreaList.filter(
        (s) => s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.SOS
      );
    },

    maxSelectTime() {
      return moment().startOf("m").toISOString();
    },
  },
  methods: {
    async sendDissmissContent() {
      this.alertNullContent = false;
      this.alertNullAccount = false;
      const event = {
        deviceEventIds: [this.eventId],
        fillAccount: this.inputAccount,
        content:this.dismissedContent === CONST.REASON_FIVE ? this.inputContent : this.dismissedContent,
        isDismiss: true,
      };

      if (event.content === "") {
        this.alertNullContent = true;
      } 
      if(event.fillAccount === ""){
        this.alertNullAccount = true;
      }

      if(event.content !== "" && event.fillAccount !== "") {
        const result = await this.$store.dispatch(
          "emergencyEvent/postEmergencyEvent",
          event
        );
        if (result.success) {
          alert("編輯成功");
          this.updateStatus = true;
        } else {
          this.updateStatus = false;
          alert("編輯失敗");
        }
      }
    },

    getTime: function (time) {
      if (Utils.isEmptyObject(time)) {
        return "-";
      }
      return moment(time).format("YYYY/MM/DD HH:mm");
    },
  },
  mounted() {},
};
</script>
<style>
body {
  min-height: 100vh;

  z-index: 1;
}
p {
  margin: 0;
}

.text-sign {
  color: #70bdc3;
}

.width-fit {
  width: fit-content;
}

legend > p {
  display: inline-block;
  line-height: unset;
  font-size: 0.8rem;
}

legend {
  font-weight: 600;
  margin-bottom: 1rem;
}
</style>
